<template>
  <div class="lookliveStyle">
    <top-component></top-component>
    <div class="contentStyle">
      <div class="content_opera">
        <!-- <a href="javascript:void(0)" @click="toBookDetail" >一键直达</a> -->
      </div>
      <div class="contentStyleChild">
            <div class="daihuo_wrap" v-if="isShow">
                <!-- <a class="getlink" :href="tolinkUrl" target='_blank'>{{ test }}</a> -->
                <a class="getlink" :href="openuri" target="_blank" @mouseover="hoverShow">
                    <img src="../../assets/images/liveLink.png" />
                </a>
                <a class="bookinfo" :href="openuri" target="_blank" v-if="isShowInfo">
                    <img :src="bookimg" />
                    <p>{{ bookname }}</p>
                    <i>讲解中</i>
                </a>
            </div>
        <!-- 直播 -->
        <iframe v-if="ZhiboTrue" id="lookLive" allowfullscreen="true" border="0" :src="src"></iframe>
        <!-- 录播 -->
        <div v-else-if="LuboTrue">
          <video style="width: 100%;height: 548px;object-fit: fill" :src="Video" muted autoplay="autoplay" loop="loop"
            controls="controls">
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <!-- 外链URL -->
        <iframe v-else-if="UrlOut" class="IframeStyle" :src="IfarmeSrc"></iframe>
        <!-- 默认视频 -->
        <div v-else>
          <video style="width: 100%;height: 548px;object-fit: fill"
            src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/sv/5d805406-1714aec9846/5d805406-1714aec9846.mp4"
            muted autoplay="autoplay" loop="loop" controls="controls">
            您的浏览器不支持 video 标签。
          </video>
        </div>
        <div class="DatePai" v-bind:style="{'height': liveDescHeight + 'px'}">
          <div class="leftDiv iconfont el-icon-arrow-left" v-if="!(DateItem.length < 5 && isRight == 0)" @click="leftClick"></div>
          <div class="RightDiv iconfont el-icon-arrow-right" v-if="!(DateItem.length < 5 && isRight == 1)" @click="rightClick"></div>
          <el-carousel class="LUnbo" indicator-position="outside" :arrow="arrow" :autoplay="false">
            <el-carousel-item class="LUnboStyle" v-for="(item, index0) in 2" :key="index0">
              <div class="jutiDate" v-for="(item, index) in DateItem" :key="index">
                <div class="styleTitle">{{item.title}}</div>
                <div class="containerStyle liveDesContent">
                  <div v-if="item.child" v-for="(item1, index1) in item.child" :key="index1" @click="ItemClick(item1)">
                    <span class="timeStyle">
                        {{item1.startTime | filtersState}}
                    </span>
                    <span class="SubjectTitle">{{item1.subject}}</span>
                    <template v-if="index1 == 0">
                        <span class="living" v-if="!item1.endTime">正在直播</span>
                        <i v-else class="iconfont iconplaying back_live"></i>
                    </template>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>
<!-- 这个页面是观众页面的直播 -->
<script>
  import { startlive, activitylistSomeDay } from '@/api/VhallLive'
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import Cookies from 'js-cookie'
  import { queryDoms } from '../../common/utils/utils'
  import { getLivelink } from '@/api/liveLink'

  export default {
    name: 'LookLive',
    data() {
      return {
        //   test:'',
        // tolinkUrl: '',
        timer: null,
        ws: null,
        isShow: false,
        isShowInfo: false,
        openuri: '',
        bookimg:'',
        bookname:'',
        webinarId:'',
        src: '',
        dateTime: '', // 请求数据日期
        isRight: 1, // 左 0；右1
        currentDate: '', // 服务器的日期，匹配议程中的日期
        arrow: "always", // 当后面没有数据的时候，never：切换箭头就设置消失
        DateItem: [], // 排程的数据
        FirstClick: true, // 议程的左点击
        FirstClickRight: true, // 议程的右点击
        ZhiboTrue: true, // 直播判断
        LuboTrue: false, // 录播判断
        UrlOut: false, // 外链url的判断
        UIShow: false, // UI判断
        IfarmeSrc: '', // 外链url成立的时候，显示的链接
        Video: '', // 录播成立的时候，显示的链接
        TixingL: '',
        liveDescHeight: 330, // 直播描述的高度
        wsUrl: '',
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
    mounted() {
      // 调取直播摄像头和麦克风document.getElementById('lookLive')
      // var iframeElment = document.getElementById('lookLive')//this.$refs.lookLive
      // if (iframeElment) {
      //   iframeElment.allow = 'microphone;camera;midi;encrypted-media;'
      // }
      // 获取日程安排
      let vm = this;
      vm.webinarId = vm.$route.params.webinarId;
      vm.dateTime = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      vm.dateShuju();
      vm.goBuyLink();
        // this.setWS('ws://220.249.72.252:11211/ws/websocket');
        // this.setWS('/ws/websocket');
        let host = window.location.host;
        vm.wsUrl = 'wss://test.ytzhihui.com/tws/websocket';
        if(host == 'www.sanxinbook.com' || host == 'rmd.ytzhihui.com'){
            vm.wsUrl = 'wss://test.ytzhihui.com/pws/websocket';
        }
        vm.setWS();
    },
    filters: {
      filtersState(value) {
        var dateF = value.split(" ")
        return dateF[1]
      }
    },
    watch: {
        isShowInfo(val){
            if(!val){
                clearTimeout(this.timer);
                this.timer = null;
                // console.log(this.timer);
            }
        }
    },
    //销毁页面之前，断开连接
    // beforeDestroy: function () {
    //     //页面离开时断开连接
    //     this.ws.onclose();
    // },
    methods: {
        hoverShow(){
            let vm = this;
            vm.isShowInfo = true;
            clearTimeout(vm.timer);
            vm.timer = null;
            vm.timer = setTimeout(() => {
                vm.isShowInfo = false;
            }, 8000);
        },
        setWS(){
            let vm= this;
            vm.ws = new WebSocket(vm.wsUrl);
            vm.ws.onopen = function() {
                console.log('握手成功！');
            };
            vm.ws.onmessage = function (e) {
                let resData = JSON.parse(e.data);
                // console.log(resData);
                clearTimeout(vm.timer);
                vm.timer = null;
                if(resData){
                    if(resData.webinarId == vm.webinarId){
                        if(resData){
                            vm.isShow = true;
                            vm.isShowInfo = true;
                            vm.timer = setTimeout(() => {
                                vm.isShowInfo = false;
                            }, 8000);
                            vm.openuri = resData.openuri;
                            vm.bookimg = resData.bookurl;
                            vm.bookname = resData.bookname;
                        }else{
                            vm.isShow = false;
                            vm.isShowInfo = false;
                        }
                    }
                }else{
                    vm.isShow = false;
                    vm.isShowInfo = false;
                }
            };

            vm.ws.onclose = function() {
                console.log("closed...");
                vm.setWS();
            };
            
            vm.ws.onerror = function () {
                // console.log(this.readyState);
            }
        },        
        goBuyLink(type){
            let vm = this;
            clearTimeout(vm.timer);
            vm.timer = null;
            getLivelink({webinarId: vm.webinarId}).then(res => {
                if(res.status && res.data.length > 0){
                    // vm.openuri = res.data[0].openuri;
                    res.data.forEach((ele, i) => {
                        if(ele.openstate == 1){
                            vm.isShow = true;
                            vm.isShowInfo = true;
                            vm.timer = setTimeout(() => {
                                vm.isShowInfo = false;
                            }, 8000);
                            vm.openuri = ele.openuri;
                            vm.bookname = ele.bookname;
                            vm.bookimg = ele.bookurl;
                        }
                    });
                    if(type == '1') window.open(href, '_blank');
                }else{
                    vm.isShow = false;
                    vm.isShowInfo = false;
                }
            }).catch(err => {

            })
        },
      // 获取日程安排
      dateShuju() {
        var obj = {
          date: this.dateTime,
          isRight: this.isRight
        }
        // console.log(obj)
        activitylistSomeDay(obj).then(response => {
        //   console.log(response)
          // 数据
          this.DateItem = response.data.groupList
          // 服务器传过来的日期
          this.currentDate = response.data.currentDate

          // 从首页跳转过来
          // 1、没有数据的话，直接显示默认或者是UI
          // 2、用服务器时间匹配议程，匹配到之后判断是直播、录播、外链Url，不然就是显示默认和UI
          if (Cookies.get('HomePage') === 'true') {
            if (response.data.groupList.length > 0) {
              for (var i = 0; i < response.data.groupList.length; i++) {
                for (var j = 0; j < response.data.groupList[i].child.length; j++) {
                //   console.log(response.data.groupList[i].child[j].startTime, response.data.groupList[i].child[j].endTime)
                  var timebefore = '' + response.data.groupList[i].child[j].startTime
                  var timeAfter = '' + response.data.groupList[i].child[j].endTime
                  if ((timebefore < this.currentDate) && (timeAfter > this.currentDate)) {
                    if (Number(response.data.groupList[i].child[j].playType) === 1) {
                      this.TixingL = '首页进来——这是直播'
                      this.ZhiboTrue = true
                      this.LuboTrue = false
                      this.UrlOut = false
                      this.UIShow = false
                      this.apiSend(response.data.groupList[i].child[j].webinarId)
                    //   console.log('首页进来——这是直播')
                    } else if (Number(response.data.groupList[i].child[j].playType) === 2) {
                      this.TixingL = '首页进来——这是录播'
                      this.ZhiboTrue = false
                      this.LuboTrue = true
                      this.UrlOut = false
                      this.UIShow = false
                      this.Video = response.data.groupList[i].child[j].playUrl
                    //   console.log(this.Video)
                    //   console.log('首页进来——这是录播')
                    } else {
                      this.TixingL = '首页进来——这是外链Url'
                      this.ZhiboTrue = false
                      this.LuboTrue = false
                      this.UrlOut = true
                      this.UIShow = false
                      this.IfarmeSrc = response.data.groupList[i].child[j].playUrl
                    //   console.log('首页进来——这是外链Url')
                    }
                    this.setContentHeight();
                    return
                  } else {
                    this.ZhiboTrue = false
                    this.LuboTrue = false
                    this.UrlOut = false
                    this.UIShow = true
                    // this.TixingL = '首页进来——服务器没有匹配到视频，显示默认视频或者是UI'
                    // console.log('首页进来——服务器没有匹配到视频，显示默认视频或者是UI')
                  }
                }
              }
            } else {
              this.ZhiboTrue = false
              this.LuboTrue = false
              this.UrlOut = false
              this.UIShow = true
            //   this.TixingL = '首页进来——服务器没有匹配到视频，显示默认视频或者是UI'
            }
          } else {
            // 从议程跳过来 1、直播  2、录播  3、外链Url
            this.UIShow = false
            if (Number(Cookies.get('playType')) === 1) {
              this.TixingL = '议程点击——这是直播'
              this.ZhiboTrue = true
              this.LuboTrue = false
              this.UrlOut = false
            //   console.log('议程点击——这是直播')
              this.apiSend(this.$route.params.webinarId)
            } else if (Number(Cookies.get('playType')) === 2) {
              this.TixingL = '议程点击——这是录播'
              this.ZhiboTrue = false
              this.LuboTrue = true
              this.UrlOut = false
            //   console.log('议程点击——这是录播')
              this.Video = Cookies.get('playUrl')
            } else {
              this.TixingL = '议程点击——这是外链Url'
              this.ZhiboTrue = false
              this.LuboTrue = false
              this.UrlOut = true
            //   console.log('议程点击——这是外链Url')
              this.IfarmeSrc = Cookies.get('linkUrl')
            }
          }

          this.setContentHeight();
        })
      },
      setContentHeight () {
          this.$nextTick(() => {
            let maxHeight = 0;
            const liveDesContents = queryDoms('.liveDesContent');
            if(!liveDesContents) {
                return
            }
            for(let i = 0, j = liveDesContents.length; i < j; i++) {
                const descHei = liveDesContents[i].offsetHeight
                if(descHei > maxHeight) {
                    maxHeight = descHei
                }
            }
            this.liveDescHeight = maxHeight + 60
          });
      },
      getTime(date, fmt) {
        var o = {
          'M+': date.getMonth() + 1, 	// 月
          'd+': date.getDate(), 		// 日 
          'h+': date.getHours(), 		// 时 
          'm+': date.getMinutes(), 	// 分 
          's+': date.getSeconds(), 	// 秒 
          'q+': Math.floor((date.getMonth() + 3) / 3), // 季度 
          'S': date.getMilliseconds() // 毫秒 
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
          }
        }

        return fmt;
      },
      // 点击每一条的数据切换直播 linkUrl
      ItemClick(item) {
        // var s = item.startTime + '',
        // time = this.getTime(new Date(),'yyyy-MM-dd h:m');
        var s = new Date(item.startTime),
        time = new Date().getTime();
        if(time < s ){
          this.$message({
              message: "当前节目还未开始！",
              type: "info",
              duration:800
          });
          return
        }
        // console.log(item)
        Cookies.set('HomePage', false)
        Cookies.set('playType', item.playType)
        Cookies.set('playUrl', item.playUrl)
        Cookies.set('linkUrl', item.linkUrl)
        if (item.playType) {
          const { href } = this.$router.resolve({
            name: "LookLiveG",
            params: { webinarId: item.webinarId }
            // params: { webinarId: item.webinarId, HomePage: false, playType: item.playType, playUrl: item.playUrl }
          })
          window.open(href, '_blank')
        } else {
          // this.$message({
          //   message: 'playType === null',
          //   type: 'success'
          // })
        }
      },
      // 获取直播的地址 https://live.vhall.com/webinar/inituser/xxxxx
      apiSend(webinarId) {
        // this.src = `https://live.vhall.com/${webinarId}`
        this.src = `https://live.vhall.com/webinar/inituser/${webinarId}`
        // console.log(this.src)
      },
      // 左点击
      leftClick() {
        // console.log('88')
        if (this.FirstClick) {
          var lengthVar = this.DateItem.length
          if(lengthVar == 0) {
              return
          }
          this.dateTime = this.DateItem[0].title
        //   console.log(this.dateTime)
          this.isRight = 0
          this.dateShuju()
          this.FirstClick = false
        } else {
        //   console.log(this.DateItem.length)
          if (this.DateItem.length < 5) {
            // console.log('什么都不用做')
          } else {
            var lengthVar = this.DateItem.length
            this.dateTime = this.DateItem[0].title
            // console.log(this.dateTime)
            this.isRight = 0
            this.dateShuju()
          }
        }
        this.FirstClickRight = true
      },
      // 右点击
      rightClick() {
        if (this.FirstClickRight) {
          var lengthVar = this.DateItem.length
          this.dateTime = this.DateItem[lengthVar - 1].title
        //   console.log(this.dateTime)
          this.isRight = 1
          this.dateShuju()
          this.FirstClickRight = false
        } else {
        //   console.log(this.DateItem.length)
          if (this.DateItem.length < 5) {
            // console.log('什么都不用做')
          } else {
            var lengthVar = this.DateItem.length
            this.dateTime = this.DateItem[lengthVar - 1].title
            // console.log(this.dateTime)
            this.isRight = 1
            this.dateShuju()
          }
        }
        this.FirstClick = true
      },
      
      // 万年历封装 date:yyyy-mm-dd;
      // days +n：n天后 dateTime1 = this.addDate(this.dateTime, n)
      // days -n： n天前 dateTime2 = this.addDate(this.dateTime, -n)
      addDate(date, days) {
        var d = new Date(date)
        d.setDate(d.getDate() + days)
        var m = d.getMonth() + 1
        return d.getFullYear() + '-' + m + '-' + d.getDate()
      },
    //   toBookDetail(){
    //     Cookies.set('LookPubgoodsIdDetaildataID', 1204609);
    //     let routeUrl = this.$router.resolve({
    //         path: "/BookDetail",
    //     });
    //     window.open(routeUrl.href, '_blank');
    //   }
    }
  }
</script>

<style scoped lang="scss">
  .lookliveStyle {
    width: 100%;
  }
  .contentStyle {
    width: 100%;
    background-image: url('../../assets/images/BGLive.jpg');
  }
  .content_opera{
    margin-left: calc(50% - 590px);
    padding: 0;
    height:50px;
    width: 1180px;
    a{
      float: right;
      height: 40px;
      line-height: 40px;
      width: 220px;
      margin-top: 5px;
      display: block;
      text-align: center;
      border-radius: 20px;
      background-color: rgba(251, 125, 15, 1);
      font-size: 18px;
      text-decoration: none;
      color: white;

    }
  }

  .contentStyleChild {
    margin-left: calc(50% - 590px);
    padding:0;
    width: 1180px;
    position:relative;
    .daihuo_wrap{
        position:absolute;
        left:20px;
        top:20px;
        display: inline-block;
        // color:#fff;
        // background-color:rgba(45, 168, 177, 0.7);
        // background: ;
        // box-shadow: 0px 0px 5px rgba(255, 255, 255, 0.7);
        // border-radius:999px;
        // line-height:40px;
        // height:40px;
        // padding:0px 20px;
        // font-size:14px;
        width:220px;
        z-index:9;
        cursor:pointer;
        .getlink{
            animation: mymove 0.3s infinite;
            -webkit-animation: mymove 0.3s infinite;
            img{
                width:100%;
            }
        }
    }   
    @keyframes mymove {
        0%{
            transform: rotate(1deg);
        }
        50%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(-1deg);
        }
    }
    @-webkit-keyframes mymove {
        0%{
            transform: rotate(1deg);
        }
        50%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(-1deg);
        }
    }
    .bookinfo::before{
        display: block;
        content: '';
        width:0px;
        height: 0px;
        border-bottom: 10px solid #fff;        
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        position: absolute;
        top:-9px;
        left:15px;
    }
    .bookinfo{
        position:absolute;
        left:20px;
        top:60px;
        display: block;
        // box-shadow: 0px 0px 5px rgba(255, 255, 255, 0.9);
        text-align: center;
        // width:118px;
        padding:3px;
        // height:120px;
        background-color: #fff;
        border-radius:4px;
        img{
            width:110px;
        }
        i{
            position:absolute;
            top:3px;
            left:3px;
            padding:0px 2px;
            font-size:12px;
            color:#fff;
            font-style: normal;
            background-color: rgb(255, 196, 0);
        }
        p{
            position: absolute;
            bottom:3px;
            left:3px;
            width:100px;
            color:#fff;
            background-color: rgba(0, 0, 0, 0.3);
            padding:0px 5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 28px;
            font-size:13px;
        }
    }
    .getlink:hover .bookinfo{
        display: block !important;
    }
  }

  /* 看直播 */
  #lookLive {
    width: 100%;
    height: 550px;
    object-fit: fill
  }

  .IframeStyle {
    width: 1180px;
    height: 550px;
  }

  /* 列表内容 */
  .DatePai {
    width: 100%;
    height: 1000px;
    background-color: #F0F0F0;
    margin-top: 20px;
    position: relative;
    /* overflow: hidden; */
    cursor: pointer;
  }

  /* 左按钮 */
  .leftDiv {
    position: absolute;
    left: -80px;
    top: 45%;
    width: 50px;
    height: 50px;
    background-color: #ed9014;
    cursor: pointer;
    z-index: 10000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    z-index: 10000;
  }

  /* 右按钮 */
  .RightDiv {
    position: absolute;
    right: -80px;
    top: 45%;
    width: 50px;
    height: 50px;
    background-color: #ed9014;
    cursor: pointer;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    z-index: 10000;
  }

  .LUnbo,
  .LUnboStyle {
    width: 100%;
    height: 100%;
  }

  .LUnboStyle {
    display: flex;
    justify-content: space-around;
  }

  .LUnbo>>>.el-carousel__container {
    height: 100%;
  }

  .jutiDate {
    width: 200px;
  }

  .containerStyle {
    width: 100%;
    border-right: 1px solid rgba(0, 0, 0, 0.20);
  }


  .jutiDate:last-child .containerStyle {
    border-right: none;
  }

  .containerStyle>div {
    padding-left: 40px;
    padding-right: 13px;
    margin-bottom: 9px;
    line-height: 26px;
  }

  /* title */
  .styleTitle {
    color: #434343;
    font-size: 21px;
    margin-top: 10px;
    margin-left: 13px;
    margin-bottom: 12px;
  }

  /* 时间 */
  .timeStyle {
    color: #434343;
    font-size: 12px;
    margin-right: 5px;
    margin-left: -40px;
  }
  .containerStyle .living {
      background-color: rgb(41, 141, 248);
      color: #ffffff;
      font-size: 12px;
      padding: 2px 4px;
      border-radius: 4px;
  }

  .back_live {
      color: rgb(41, 141, 248);
  }

  /* 内容 */
  .SubjectTitle {
    color: #333;
    font-size: 14px;
  }

  /* 下面的鼠标悬浮事件去掉 */ 
  .DatePai>>>.el-carousel__indicators--outside {
    display: none;
  }
  .DatePai>>>.el-carousel__arrow--right {
  display: none !important;
}
.DatePai>>>.el-carousel__arrow--left {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/Look-LiveG.vue